import { Condition } from '@/shared/api/protocol-ts/model/dto_report_condition_pb';

import { conditionHasModelData } from './conditionHasModelData';

const PERCENT_ROUNDING_EPSILON = 1e-6;

export const getConditionModelScorePercentage = (
  condition?: Condition,
): string => {
  const certainty = condition?.Certainty;

  if (!conditionHasModelData(certainty)) {
    return '';
  }

  const score = certainty?.ModelScore ?? 0;

  return `${Math.trunc(score * 100 + PERCENT_ROUNDING_EPSILON)}%`;
};
